import React from 'react'
import {Flex} from '/app/src/component'
import { connect } from 'react-redux'
import Wizard from './Wizard/index'
import TutorialModel from '/app/src/model/Tutorial/model';

class TutorialItem extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            cardColor: 'white',
            modal: false,
        }

        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._openModal = this._openModal.bind(this);

        this.closeModal = this.closeModal.bind(this);
    }

    _onMouseLeave(){
        this.setState({
            cardColor: 'white'
        })
    }

    _onMouseEnter(e){

        this.setState({
            cardColor: '#f7f7f7'
        })

        e.stopPropagation();
    }

    _openModal(id, listId){
        this.setState({
            modal: true,
            cardColor: 'white'
        })

        this.props.dispatch(TutorialModel.setCurrentItem(id));
        this.props.dispatch(TutorialModel.setCurrentList(listId))
    }

    closeModal(e){
        this.setState({
            modal: false
        })
        //Need this to stop _openModal function from being called
        e.stopPropagation();
    }


    render(){

        let { header, description, done, name, id, listId} = this.props;
        let imgSrc = '/images/ResolveButtonGrey.png';

        let textDecoration = 'none'
        if(done){
           imgSrc = '/images/ResolveButtonBlue.png'
           //textDecoration = 'line-through'
        }
        return(
            <Flex
                column
                basis='60px'
                maxWidth='50%'
                grow
                padding='10px'
                transition='0.3s'
                cursor='pointer'
                backgroundColor={this.state.cardColor}
                onMouseEnter={this._onMouseEnter}
                onMouseLeave={this._onMouseLeave}
                onClick={() => this._openModal(id, listId)}
            >
                <Wizard name={name} open={this.state.modal} closeModal={this.closeModal}/>
                <Flex fontSize='18px' color='#4B4B4B' textDecoration={textDecoration} vAlignContent='center'>
                    <img  alt='' src={imgSrc} style={{width: 'auto', height: '20px', marginRight: '10px', position: 'relative'}}/>
                    {header}
                </Flex>
                <Flex fontSize='14px' ml='30px' color='#868686'>
                    {description}
                </Flex>
            </Flex>
        );
    }
}

function mapStateToProps(state, ownProps)
{
    return {

    };
}

export default connect(mapStateToProps)(TutorialItem);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Tutorial/TutorialItem.js